import styled from "styled-components";

export const FormWrapper = styled.div`
  margin: 0 -24px !important;

  #FormPanel {
    background-color: ${({ theme }) => theme.colors.primaryLightFill};
  }

  ${({ theme }) => theme.media.exceptSmallMobile`
    margin: 0 -16px !important;
  `}

  .form-heading {
    color: ${({ theme }) => theme.colors.primaryText};
    ${({ theme }) => theme.fontStyles.MobileHeadlinesH3}

    ${({ theme }) => theme.media.exceptMobile`
      ${({ theme }) => theme.fontStyles.DesktopHeadlinesH3}
    `}
  }

  .form-instructions {
    ${({ theme }) => theme.fontStyles.DesktopCopyBodyCopySmall}
  }

  .field-block {
    margin: 24px 0;
  }

  .sources {
    padding-top: 16px;
    label {
      margin: 0;
      max-width: 420px;
    }
  }

  button {
    margin-top: 16px;
  }

  form {
    > span.error {
      display: block;
      height: 12px;
      ${({ theme }) => theme.fontStyles.InterfaceCopySmall}
      color: ${({ theme }) => theme.colors.offTrackText};
      padding-top: 4px;
    }
  }
`;

export const GroupsWrapper = styled.div`
  > div {
    &.grouped {
      padding: 16px;
      border-radius: 4px;
      margin: 16px;
    }

    .title {
      font-weight: 600;
      font-size: 16px;
    }
  }
`;
